<style lang="less" scoped>
</style>

<template>
    <div class="detail-container">
        <div class="detail-bread-crumb-div">
            <ZD-bread-crumb :bConfigList="pageConfig.detailBreadCrumb"></ZD-bread-crumb>
        </div>
        <div class="detail-content-div">
            <div class="detail-content-header-div flex">
                <div class="left-page-title-div flex-1">{{pageTitle}}</div>
            </div>
            <div class="detail-content-body-div flex-1">
                <el-form :model="detailForm" :rules="pageConfig.formRules" ref="detailForm" label-width="120px" class="detail-form">
                    <el-row :gutter="20">
                        <el-col :span="8">
                            <el-form-item label="公司名称" prop="userName">
                                <el-input v-model="detailForm.userName" size="small" disabled='editFlag'></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item label="国内/海外" prop="userPassword">
                                <el-input v-model="detailForm.userPassword" size="small" disabled='editFlag'></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item label="国家" prop="userPhone">
                                <el-select class="full-width" v-model="detailForm.roleId" size="small" clearable >
                                    <el-option v-for="(item,index) in roleArr" :label="item.roleName" :value="item.roleId" :key="index" @click.native="handleRoleChange(item.roleName)"></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item label="邮政编码" prop="roleId">
                                <el-input v-model="detailForm.userPassword" size="small" disabled='editFlag'></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item label="州省/城市/区县" prop="area">
                                <el-col :span="8">
                                    <el-select class="full-width" v-model="detailForm.area.province" size="small" clearable >
                                        <el-option v-for="(item,index) in roleArr" :label="item.roleName" :value="item.roleId" :key="index" @click.native="handleRoleChange(item.roleName)"></el-option>
                                    </el-select>
                                </el-col>
                                <el-col :span="8">
                                    <el-select class="full-width" v-model="detailForm.area.city" size="small" clearable >
                                        <el-option v-for="(item,index) in roleArr" :label="item.roleName" :value="item.roleId" :key="index" @click.native="handleRoleChange(item.roleName)"></el-option>
                                    </el-select>
                                </el-col>
                                <el-col :span="8">
                                    <el-select class="full-width" v-model="detailForm.area.district" size="small" clearable >
                                        <el-option v-for="(item,index) in roleArr" :label="item.roleName" :value="item.roleId" :key="index" @click.native="handleRoleChange(item.roleName)"></el-option>
                                    </el-select>
                                </el-col>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item label="详细地址" prop="roleId">
                                <el-input v-model="detailForm.userPassword" size="small"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item label="服务器" prop="userPhone">
                                <el-select class="full-width" v-model="detailForm.roleId" size="small" clearable >
                                    <el-option v-for="(item,index) in roleArr" :label="item.roleName" :value="item.roleId" :key="index" @click.native="handleRoleChange(item.roleName)"></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item label="状态" prop="userPhone">
                                <el-radio-group>
                                    <el-radio label='01'>启用</el-radio>
                                    <el-radio label='02'>停用</el-radio>
                                </el-radio-group>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-form>
            </div>
            <div class="flex-r-end">
                <button class="common-bg-button" @click="submitForm('detailForm')">提 交</button>
                <button class="common-empty-button" @click="resetForm">取 消</button>
            </div>
        </div>
    </div>
</template>

<script>
    import enAes from "../../../common/enAes";
    import pageConfig from './page-config';
    export default {
        data() {
            return {
                pageConfig,
                editFlag:false,//是否编辑模式
                pageTitle:'公司创建',//标题
                // 默认值设置
                detailForm: {  //表单内容信息
                    area:{
                        province:'',
                        city:'',
                        district:'',
                    }
                },
                statueArr:[],  //账号状态下拉框
                roleArr:[],     //角色权限下拉框
                SaaSFlag:false, //是否为运营商
                dealerArr:[],   //运营商下拉框
            }
        },
        methods: {
            //判断是否为编辑模式  获取信息
            init() {
                if(this.$store.state.editId){
                    this.editFlag = true;
                    this.pageTitle = "公司编辑";
                    this.getFormInfo();
                }
                this.getConfig();
                this.getDealer();
            },
            // 获取表单信息
            getFormInfo(){
                let _ = this;
                _.$S.getFormInfo(_,_.$A.user.list +'/'+_.$store.state.editId,function(res){
                     _.detailForm = res.data.data;
                     _.detailForm.userPassword = enAes.Decrypt(_.detailForm.userPassword);
                     if(_.detailForm.dealNo){
                         _.SaaSFlag = true;
                     }
                });
            },
            //获取角色权限下拉框
            getConfig(){
                let _ = this;
                _.$H.post(_,_.$A.config.list,{configType:"192"}).then(res => {
                    _.statueArr = res.data.data;
                })
                let obj = {};
                let dealerNo = _.$store.state.userInfo.dealNo;
                if(dealerNo){
                    obj.dealerNo = dealerNo;
                }
                _.$H.post(_,_.$A.role.allrole,obj).then(res => {
                    _.roleArr = res.data.data;
                })
            },
            //运营商下拉框
            getDealer(){
                let _ = this;
                _.$H.post(_,_.$A.dealer.allList,{}).then(res => {
                    _.dealerArr = res.data.data;
                })
            },
            //选择账号归属
            handleDataCheckChange(){
                if(this.detailForm.dataCheck == "Y"){
                    this.SaaSFlag = true;
                    var dealerNo = '1'
                    this.handleDealChange(dealerNo);
                }else{
                    this.SaaSFlag = false; 
                    this.getConfig();
                }
                this.detailForm.roleId = ''
            }, 
            // 表单提交
            submitForm(formName) {
                let _ = this;
                _.detailForm.corpNo = _.$store.state.corpNo;
                if(_.detailForm.dataCheck == 'N'){
                    _.detailForm.dealNo = ''
                }
                _.detailForm.dealerNo = _.detailForm.dealNo;
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        // _.detailForm.userPassword = enAes.Encrypt(_.detailForm.userPassword);
                        _.$S.submitForm(_, _.$A.user.list, _.editFlag, _.detailForm, pageConfig.listRouter);
                    }
                });
            },
            // 选择角色权限
            handleRoleChange(val){
                this.detailForm.roleName = val;
            },
            //选择角色权限
            handleDealChange(val){
                let obj = {};
                let _ = this
                obj.dealerNo = val;
                _.detailForm.roleId = ''
                _.roleArr = []
                _.$H.post(_,_.$A.role.allrole,obj).then(res => {
                    _.roleArr = res.data.data;
                })
            },
            // 取消
            resetForm() {
                this.$router.push({
                    name: pageConfig.listRouter
                })
            }
        },
        mounted() {
            this.init();
        }
    }
</script>